import { MapContext } from 'components/Mapbox/Mapbox'
import { CTRLPositions } from 'components/Mapbox/Types/mapboxtypes'
import { useContext, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import FullScreen from './FullScreen'
import ExitFullScreen from './ExitFullScreen'
import { CustomControl } from '../Utils/CreateCustomControl'
import { renderToString, renderToStaticMarkup } from 'react-dom/server'

export const FullScreenControl = ({
  position = 'top-right',
}: {
  position?: CTRLPositions
}) => {
  const [on, setOn] = useState(false)
  const [control, setControl] = useState<CustomControl | undefined>()
  var context = useContext(MapContext)
  var className = 'fullscreen-control'

  const handleClick = (e: boolean) => setOn(!on)

  useEffect(() => {
    if (control) control.action = (e: boolean) => setOn(!on)
    context.setFullscreen && context.setFullscreen(!context.isFullscreen)
    context.map?.resize()
    if (!on) {
      context.setIsInteractive && context.setIsInteractive(false)
    }
    const turnOn = () => setOn(true)
    const turnOff = () => setOn(false)

    if (control && control?.container) {
      control.container.removeEventListener('click', turnOn)
      control.container.removeEventListener('click', turnOff)
      control.container.addEventListener('click', on ? turnOff : turnOn)
      control.container.innerHTML = renderToString(
        <FSButton on={!!context.isFullscreen} />
      )
    }
  }, [on])

  function addControl(action: (e: boolean) => void) {
    if (!context.map || !context.setFullscreen || control) return
    var c = new CustomControl(
      action,
      context.map,
      <FSButton on={on} />,
      className
    )
    context.map.addControl(c, position)
    setControl(c)
  }
  console.log("FULLSCREEN CONTROL")
  useEffect(() => {
    if (context.isMobile) return
    addControl(handleClick)
  }, [position, context.isFullscreen, context.map])

  return null
}

const FSButton = ({ on }: { on: boolean }) => {
  return (
    <ControlButton className='control-button' style={{ pointerEvents: 'all' }}>
      <>
        {!on && <FullScreen />}
        {on && <ExitFullScreen />}
      </>
    </ControlButton>
  )
}

const ControlButton = styled.button``
